import React from 'react'
import { isMobile } from 'react-device-detect'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  PixelFlexBox,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  Section,
  SectionContent,
} from 'pixel-base'
import { get } from 'utils/api-routes.util'
import CheckIcon from 'utils/icons/check-icon'
import PenIcon from 'utils/icons/pen-icon'
import PlusIcon from 'utils/icons/plus-icon'
import XmarkIcon from 'utils/icons/xmark-icon'

import OrderSourceForm from './components/OrderSourceForm'
import { colors } from '../../../../../../shared/pixel-base/components/styleGuide'

const OrderSources = () => {
  const [sources, setSources] = React.useState<any>([])
  const [showNewModal, setShowNewModal] = React.useState(false)
  const [editingSource, setEditingSource] = React.useState(false)
  const [tableLoading, setTableLoading] = React.useState(true)

  const readData = () => {
    setTableLoading(true)
    get('/settings/order/sources').subscribe((res: any) => {
      setSources(res.response.data)
      setTableLoading(false)
    })
  }
  const columns = [
    {
      dataKey: 'code',
      name: 'Code',
      sortable: true,
      selector: (row) => row.code,
    },
    {
      dataKey: 'description',
      name: 'Description',
      sortable: true,
      selector: (row) => row.description,
    },
    {
      dataKey: 'total_orders',
      name: 'Total Orders ',
      sortable: true,
      selector: (row) => row.total_orders,
    },
    {
      dataKey: 'is_default',
      name: 'Is Default ?',
      sortable: true,
      selector: (row) =>
        row.is_default === '1' ? (
          <CheckIcon color="green" size={16} />
        ) : (
          <XmarkIcon color="red" size={16} />
        ),
    },
    {
      dataKey: 'actions',
      name: 'Actions',
      selector: (row) => <PixelTableAction row={row} action={actions} />,
    },
  ]
  const breadcrumbs = [
    {
      name: 'Settings',
      active: false,
    },
    {
      name: 'Order Sources',
      active: true,
    },
  ]
  const actions = [
    {
      title: 'Edit',
      icon: (
        <Section>
          <PenIcon
            style={{ cursor: 'pointer', color: colors.primary }}
            size={18}
          />
        </Section>
      ),
      clickHandler: (row) => {
        setEditingSource(row)
        setShowNewModal(true)
      },
    },
  ]
  React.useEffect(() => {
    readData()
  }, [])

  const handleCloseModal = (data: any, action) => {
    if (action === 'add') {
      setSources([data, ...sources])
    } else if (action === 'update') {
      const newSources = sources.map((source) => {
        if (source.code === data.code) {
          return data
        }
        return source
      })
      setSources(newSources)
    }
    setShowNewModal(false)
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0 ' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <PixelFlexBox
              width="100%"
              padding=" 5px 20px"
              justifyContent="flex-end"
              height="auto"
            >
              <DcButton
                size="sm"
                onClick={() => {
                  setEditingSource(false)
                  setShowNewModal(true)
                }}
              >
                <PlusIcon size={18} color="white" /> Add {!isMobile && 'Source'}
              </DcButton>
            </PixelFlexBox>
          </SectionContent>
        </Section>
        <Section
          style={{
            padding: '20px',
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
          }}
          isMobile={isMobile}
        >
          <SectionContent isMobile={isMobile}>
            <PixelTable
              columns={columns}
              data={sources}
              progressPending={tableLoading}
              fixedHeader
              fixedHeaderScrollHeight="calc(100vh - 212px)"
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>

      {showNewModal && (
        <DcOverlaySlider
          title={`${editingSource ? 'Update' : 'Create'} Order Channel`}
          onClose={() => setShowNewModal(false)}
          isOpen={showNewModal}
          width="40%"
        >
          <SectionContent>
            {showNewModal && (
              <OrderSourceForm
                editingSource={editingSource}
                handleClose={handleCloseModal}
              />
            )}
          </SectionContent>
        </DcOverlaySlider>
      )}
    </>
  )
}

export default OrderSources
